import $ from "jquery";

const Scroll = (Selector) => $("html, body").animate({ scrollTop: $(Selector).offset().top }, 1000);

export {Scroll};
